export const LOGGED_OUT_COOKIE = 'sacon.logged-out';
const LOGGED_OUT_COOKIE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

/** 종료 표식은 인증을 허용하지 않으며, 늦게 도착한 이전 세션 쿠키의 재사용만 차단합니다. */
export function hasLoggedOutCookie(cookieHeader: string | null): boolean {
  return cookieHeader?.split(';').some(cookie => cookie.trim() === `${LOGGED_OUT_COOKIE}=1`) === true;
}

export function createLoggedOutCookie(secure: boolean): string {
  return `${LOGGED_OUT_COOKIE}=1; Path=/; Max-Age=${LOGGED_OUT_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure ? '; Secure' : ''}`;
}

/** 새 로그인에서 세션을 발급한 응답만 종료 표식을 해제할 수 있습니다. */
export function hasIssuedAuthSessionCookie(setCookies: string[]): boolean {
  return setCookies.some(cookie => /^(?:__Secure-)?(?:authjs|next-auth)\.session-token(?:\.\d+)?=[^;]+/.test(cookie));
}
